export default "__VITE_ASSET__B1l8YZ9q__"